import { Box, IconButton } from "@mui/material";
import { Header } from "../Header/Header";
import { ReactNode } from "react";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import { useLocation, useNavigate } from "react-router-dom";
import { ROUTES } from "../../router/constants";

interface LayoutProps {
  children: ReactNode;
}

export function Layout({ children }: LayoutProps) {
  const { user } = useSelector((state: RootState) => state.userInfo);
  const navigate = useNavigate();
  const location = useLocation();

  const isUserRole = user?.role?.toLowerCase() === "user";
  const defaultBackRoute = isUserRole ? ROUTES.HOME : ROUTES.DASHBOARD;
  const currentPath = location.pathname.toLowerCase();
  const shouldShowBackButton = currentPath !== defaultBackRoute.toLowerCase();

  const handleBackClick = () => {
    navigate(defaultBackRoute);
  };
  return (
    <Box sx={{ width: "100%" }}>
      <Header />
      <Box sx={{ paddingTop: "64px", width: "100%" }}>
        {shouldShowBackButton && (
          <Box
            sx={{
              width: "100%",
              maxWidth: 1200,
              mx: "auto",
              px: { xs: 2, sm: 3, lg: 0 },
              pt: 1,
              pb: 0.5,
              display: "flex",
              alignItems: "center",
            }}
          >
              <IconButton
                onClick={handleBackClick}
                aria-label="Voltar"
                sx={{
                  color: "#133859",
                  border: "1px solid #D9E2EC",
                  backgroundColor: "#fff",
                  "&:hover": {
                    backgroundColor: "#EEF3F8",
                  },
                }}
              >
                <ArrowBackIcon fontSize="small" />
              </IconButton>
          </Box>
        )}
        {children}
      </Box>
    </Box>
  );
}
